import React from "react";
import { Link } from "react-router-dom";
import { LinktoFaq } from "../buttons/linktoFaq";
import { LinktoHowto } from "../buttons/linktoHowto";
import { LinktoSelect } from "../buttons/linktoSelect";
import { LinktoTop } from "../buttons/linktoTop";
import logoe from "../../img/logo_e.png";

export const GeographHeader = (props) => {
  return (
    <>
      <div className="text-white bg-gradient-to-r from-blue-600 to-blue-800 font-medium text-base md:text-2xl text-center pointer-events-auto absolute z-20 text-black/80 flex w-full">
        <Link to="/">
          <img
            src={logoe}
            className="p-1 md:p-1 m-1 h-8 md:h-12 max-w-1/3"
            alt="logo"
          />
        </Link>
        <div className="grow"></div>
        <div className="text-white ">
          <div className="z-40 flex flex-row-reverse text-xs md:text-base">
            <div className="bg-gradient-to-r from-black/50 via-black/70 to-black/90 hover:bg-gradient-to-br focus:ring-4 focus:ring-green-800/50 dark:focus:ring-green-800/50 p-1 md:p-2 mr-1 my-2 md:my-2 rounded">
              <LinktoTop />
            </div>
            <div className="bg-gradient-to-r from-black/50 via-black/70 to-black/90 hover:bg-gradient-to-br focus:ring-4 focus:ring-green-800/50 dark:focus:ring-green-800/50 p-1 md:p-2 mr-1 my-2 md:my-2 rounded">
              <LinktoFaq />
            </div>
            <div className="bg-gradient-to-r from-black/50 via-black/70 to-black/90 hover:bg-gradient-to-br focus:ring-4 focus:ring-green-800/50 dark:focus:ring-green-800/50 p-1 md:p-2 mr-1 my-2 md:my-2 rounded">
              <LinktoHowto />
            </div>
            <div className="bg-gradient-to-r from-black/50 via-black/70 to-black/90 hover:bg-gradient-to-br focus:ring-4 focus:ring-green-800/50 dark:focus:ring-green-800/50 p-1 md:p-2 mr-1 my-2 md:my-2 rounded">
              <LinktoSelect />
            </div>
          </div>
        </div>
      </div>
      <div className="w-full absolute z-30 pointer-events-none">
        {props.children}
      </div>

    </>
  );
};
